import { Injectable } from '@angular/core';
import { gql, Subscription } from 'apollo-angular';

const APPLICATION_TASK_SUBSCRIPTION = gql`
subscription taskEvents($applicationId: String, $taskEventType: String){
    onApplicationTaskEvent( input:{ applicationId:$applicationId, taskEventType:$taskEventType }) {
    data {
      description
      displayName
      initiatingUserId
    }
  }
}
`;

@Injectable({
  providedIn: 'root'
})
export class ApplicationTaskSubscriptionService extends Subscription {
  document = APPLICATION_TASK_SUBSCRIPTION;
}
